import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "statistic" }
const _hoisted_2 = { class: "statistic-filter" }
const _hoisted_3 = { class: "filters" }
const _hoisted_4 = {
  class: "form",
  id: "statistic-form"
}
const _hoisted_5 = { class: "form-block form-block--30" }
const _hoisted_6 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_7 = { class: "form-block form-block--30" }
const _hoisted_8 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_9 = { class: "form-block form-block--30" }
const _hoisted_10 = { class: "pay-method" }
const _hoisted_11 = {
  class: "overflow-hidden",
  style: {"white-space":"nowrap","text-overflow":"ellipsis"}
}
const _hoisted_12 = { class: "form-block form-block--30" }
const _hoisted_13 = { class: "form-block form-block--30" }
const _hoisted_14 = {
  key: 0,
  class: "form-block form-block--30"
}
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = { class: "form__controls w-100" }
const _hoisted_17 = { class: "text-capitalize-first" }
const _hoisted_18 = { class: "text-capitalize-first" }
const _hoisted_19 = { class: "text-capitalize-first" }
const _hoisted_20 = { class: "statistic-block__title" }
const _hoisted_21 = { class: "text-capitalize-first" }
const _hoisted_22 = { class: "statistic-block__top" }
const _hoisted_23 = { class: "statistic-block__info" }
const _hoisted_24 = { class: "statistic-block__info-title" }
const _hoisted_25 = { class: "text-capitalize-first" }
const _hoisted_26 = { class: "statistic-block__count" }
const _hoisted_27 = { class: "statistic-block__details" }
const _hoisted_28 = { class: "statistic-block__detail" }
const _hoisted_29 = { class: "text-capitalize-first" }
const _hoisted_30 = { class: "statistic-block__detail" }
const _hoisted_31 = { class: "text-capitalize-first" }
const _hoisted_32 = { class: "statistic-block__detail" }
const _hoisted_33 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_DevicesMultiselect = _resolveComponent("DevicesMultiselect")!
  const _component_LoaderButton = _resolveComponent("LoaderButton")!
  const _component_LoaderContent = _resolveComponent("LoaderContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_DatePicker, {
              modelValue: _ctx.requestDTO.fromDate,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestDTO.fromDate) = $event)),
              mode: "dateTime",
              "model-modifiers": {string: true},
              is24hr: "",
              masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
            }, {
              default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                _createElementVNode("input", {
                  class: "form-control form-control-sm",
                  placeholder: _ctx.helper.trans('labels.from_date'),
                  value: inputValue,
                  onFocus: togglePopover,
                  onChange: inputEvents.change
                }, null, 40, _hoisted_6)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_DatePicker, {
              modelValue: _ctx.requestDTO.toDate,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestDTO.toDate) = $event)),
              mode: "dateTime",
              "model-modifiers": {string: true},
              is24hr: "",
              masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
            }, {
              default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                _createElementVNode("input", {
                  class: "form-control form-control-sm",
                  placeholder: _ctx.helper.trans('labels.to_date'),
                  value: inputValue,
                  onFocus: togglePopover,
                  onChange: inputEvents.change
                }, null, 40, _hoisted_8)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Multiselect, {
              id: "methods",
              class: "multiselect-sm",
              modelValue: _ctx.requestDTO.methods,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requestDTO.methods) = $event)),
              options: _ctx.store.getters['currencyMethods/methods'](),
              "custom-label": (opt) => _ctx.helper.trans(`pay_methods.${opt}`),
              multiple: true,
              "select-label": "Select",
              placeholder: _ctx.helper.trans('labels.payment_methods')
            }, {
              option: _withCtx((props) => [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_PayMethodIcon, {
                    "icon-class": "icon",
                    method: props.option
                  }, null, 8, ["method"]),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.helper.trans('pay_methods.' + props.option)), 1)
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "options", "custom-label", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_Multiselect, {
              id: "options",
              class: "multiselect-sm",
              modelValue: _ctx.requestDTO.options,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestDTO.options) = $event)),
              options: _ctx.store.getters['currencyMethods/options'](),
              "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
              multiple: true,
              "select-label": "Select",
              placeholder: _ctx.helper.trans('labels.payment_options')
            }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_DevicesMultiselect, {
              ref: "deviceMultiselect",
              multiple: true,
              "trader-ids": _ctx.tradersFilter.map((item) => item.id),
              modelValue: _ctx.devicesFilter,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.devicesFilter) = $event))
            }, null, 8, ["trader-ids", "modelValue"])
          ]),
          (_ctx.store.getters.isTrader || _ctx.store.getters.isTraderOperator)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control form-control-sm",
                  type: "text",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.requestDTO.requisites) = $event)),
                  onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)), ["prevent"]), ["enter"])),
                  placeholder: _ctx.helper.trans('labels.requisitesOrHolder')
                }, null, 40, _hoisted_15), [
                  [_vModelText, _ctx.requestDTO.requisites]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_LoaderButton, {
              "on-click": _ctx.applyFilters,
              class: "form__btn btn"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('button.apply')), 1)
              ]),
              _: 1
            }, 8, ["on-click"]),
            _createVNode(_component_LoaderButton, {
              "on-click": _ctx.clearFilters,
              class: "form__btn form__btn--reset btn btn--2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('button.reset')), 1)
              ]),
              _: 1
            }, 8, ["on-click"]),
            (_ctx.canExport)
              ? (_openBlock(), _createBlock(_component_LoaderButton, {
                  key: 0,
                  "on-click": _ctx.downloadReport,
                  class: "form__btn btn btn-sm rounded-pill ms-auto"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('button.export')), 1)
                  ]),
                  _: 1
                }, 8, ["on-click"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_LoaderContent, { ref: "loader" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedGroups, (group) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: group.groupId
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.byDirections, (typeStat, type) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "statistic-block",
                key: type
              }, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t(`direction.${type}`)), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (status) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: status }, [
                    (typeStat[status])
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["statistic-block__container", {'statistic-block__container--summary': status === 'total'}])
                        }, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t(`deal_status.${status}`)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_26, [
                                _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatNumber(typeStat[status].count)) + " ", 1),
                                _createElementVNode("sup", null, _toDisplayString(_ctx.numberFormatter.formatNumber(group.countByDirections[type] ? typeStat[status].count/group.countByDirections[type] * 100 : 0, 1)) + "%", 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('labels.taker_sum')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeStat[status].takerSums, (sum, currency) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "statistic-block__sum",
                                  key: currency
                                }, _toDisplayString(_ctx.numberFormatter.formatMoney(sum)), 1))
                              }), 128))
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("span", _hoisted_31, _toDisplayString(type === _ctx.Direction.PAY_IN ? _ctx.$t('labels.trader_sum_out') : _ctx.$t('labels.trader_sum_in')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeStat[status].makerSums, (sum, currency) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "statistic-block__sum",
                                  key: currency
                                }, _toDisplayString(status !== _ctx.DealStatus.COMPLETED ? '' : type === _ctx.Direction.PAY_IN ? '-' : '+') + _toDisplayString(_ctx.numberFormatter.formatMoney(sum, _ctx.usdtSubunits)), 1))
                              }), 128))
                            ]),
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('labels.rewards')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeStat[status].traderRewardSums, (sum, currency) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "statistic-block__sum",
                                  key: currency
                                }, _toDisplayString(status !== _ctx.DealStatus.COMPLETED ? '' : '+') + _toDisplayString(_ctx.numberFormatter.formatMoney(sum, _ctx.usdtSubunits)), 1))
                              }), 128))
                            ])
                          ])
                        ], 2))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]))
            }), 128))
          ], 64))
        }), 128))
      ]),
      _: 1
    }, 512)
  ]))
}